import * as actionTypes from './actionTypes';

export const setThemeData = (themeType) => {
  return {
    type: actionTypes.SET_THEME_DATA,
    themeType,
  };
};
